import '../../styles-new/pages/vacancies/vacancy-application.scss';

const breadcrumbsDotsButton = document.querySelector('.breadcrumbs__dots-button');

breadcrumbsDotsButton.addEventListener('click', () => {
  const collapsed = document.getElementById('breadcrumbsCollapsed');
  const expanded = document.getElementById('breadcrumbsExpanded');

  if (collapsed.style.display !== 'none') {
    collapsed.style.display = 'none';
    expanded.style.display = 'flex';
  } else {
    collapsed.style.display = 'flex';
    expanded.style.display = 'none';
  }
});

// File input functionality
const fileInput = document.querySelector('input[type="file"]');
const fileFieldHint = document.querySelector('.file-field__hint');

if (fileInput && fileFieldHint) {
  fileInput.addEventListener('change', function () {
    if (this.files && this.files[0]) {
      const fileName = this.files[0].name;
      const fileSize = (this.files[0].size / (1024 * 1024)).toFixed(2); // Convert to MB

      // Update the hint text to show selected file info
      fileFieldHint.textContent = `Вибрано: ${fileName} (${fileSize} МБ)`;
      fileFieldHint.style.color = '#2D2D2D'; // Change color to indicate file is selected

      // Hide any error messages when a new file is selected
      const fileField = this.closest('.file-field');
      if (fileField) {
        const errorList = fileField.querySelector('.errorlist');
        if (errorList) {
          errorList.style.display = 'none';
        }
      }
    } else {
      // Reset to default text if no file selected
      fileFieldHint.textContent = 'Прикріпіть файл з резюме (.doc, .docx, .txt, .pdf до 5 Мб.)';
      fileFieldHint.style.color = '#ADADAD';
    }
  });
}
